import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    isMobile : false
}
const getters = {
}
const actions = {

}
const mutations = {
    changeView(state,value){
        state.isMobile = value
    }
}
export default new Vuex.Store({
    state,mutations,getters,actions
})


// WEBPACK FOOTER //
// ./src/views/store/store.js